<template>
    <div>
        <modal-intervention-view
        v-if="selectedInterventionId"
        :intervention-id="selectedInterventionId"
        />
            <!-- @unplanned="refreshInterventions" -->

        <modal name="modal-view-chantier" height="auto" :adaptive="true" width="1100px" classes="rounded-2xl shadow-2xl overflow-hidden">
            <div class="bg-white p-2">
                <div class="overflow-y-auto max-h-[90vh] min-h-[80vh] rounded-xl bg-gray-50/50 p-8">
                    <div v-if="selectedChantierId">
                        <div class="flex justify-between items-center mb-8">
                            <div class="flex items-center gap-3">
                                <div class="w-10 h-10 rounded-xl bg-orange-600 text-white flex items-center justify-center">
                                    <i class="fas fa-hard-hat text-sm"></i>
                                </div>
                                <h2 class="text-xl font-bold tracking-tight">Détails du chantier</h2>
                            </div>
                            <button @click="$modal.hide('modal-view-chantier')" class="w-9 h-9 rounded-lg hover:bg-slate-100 transition-all flex items-center justify-center text-slate-400 hover:text-red-500">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <chantier-view :chantier-id="selectedChantierId" />
                    </div>
                </div>
            </div>
        </modal>

        <app-template>
            <div class="bg-white rounded shadow p-4">
                <!-- <planning-planner /> -->
                <!-- :chantier-id="20" -->
                <!-- :intervention-to-plan="2190" -->
                <planning-half-day
                :days="$account.account.societe.open_days"
                :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                heurefin-matin="12:00"
                heure-debut-apres-midi="12:01"
                :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                :readonly="true"
                @event-click="onEventClick"
                />
            </div>
        </app-template>
    </div>
</template>

<script>
// import PlanningPlanner from './Components/PlanningPlanner.vue';
import PlanningHalfDay from './Components/PlanningHalfDay.vue';
import ModalInterventionView from '../Intervention/Components/ModalInterventionView.vue';
import ChantierView from '../Chantier/Components/ChantierView.vue';

export default {
    components: {
        // PlanningPlanner
        PlanningHalfDay,
        ModalInterventionView,
        ChantierView
    },
    data() {
        return {
            selectedInterventionId: null,
            selectedChantierId: null
        }
    },
    methods: {
        onEventClick(event) {
            if (event.type == 'intervention') {
                this.selectedInterventionId = event.interventionId;
                this.$nextTick(() => {
                    this.$modal.show("modal-view-intervention-" + event.interventionId)
                })
            }
            if (event.type == 'chantier') {
                console.log(event);
                
                this.selectedChantierId = event.chantierId;
                this.$nextTick(() => {
                    this.$modal.show("modal-view-chantier")
                })
            }
        }
    }
            
}
</script>

<style lang="scss" scoped>

</style>